export interface AboutSection {
  prompt: string;
  details: string;
}

export const about: AboutSection[] = [
  {
    prompt: 'How we met',
    details:
      'Briana was at work, as usual, and this Marine (Matt) was convinced she had smiled only at him. He asked her to \
      run Griffith Park and that was all she wrote.',
  },
  {
    prompt: 'How he proposed',
    details:
      "Newport, Rhode Island, sunset at the Castle Hill lighthouse, down on one knee; it's still the only \
      occasion Matt has ever been on time for.",
  },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data/about.ts